export const data = [
    {
        name: "Gaston Abaca",
        img: "https://res.cloudinary.com/dx3wowvsb/image/upload/v1673360375/photo about/1661300533257_ef3fkw.jpg",
        linkedin: "https://www.linkedin.com/in/gaston-nicolas-abaca-861a48249/",
        github:"https://github.com/GastonPro10"
    },
    {
        name: "Milagros Dziuban",
        img: "https://res.cloudinary.com/dx3wowvsb/image/upload/v1673360688/photo about/1672086255626_mrwpyy.jpg",
        linkedin: "https://www.linkedin.com/in/milagros-dziuban-dise%C3%B1adora/",
        github:"https://github.com/milidziuban"
    },
    {
        name: "Santiago Cuevas",
        img: "https://res.cloudinary.com/dx3wowvsb/image/upload/v1673360683/photo about/1650995045140_w8zryj.jpg",
        linkedin: "https://www.linkedin.com/in/santiago-cuevas-966b2b238/",
        github:"https://github.com/SantiCuevas"
    },
    {
        name: "Matias Ghigi",
        img: "https://res.cloudinary.com/dx3wowvsb/image/upload/v1673360720/photo about/1600391604731_hssifv.jpg",
        linkedin: "https://www.linkedin.com/in/matias-ghigi/",
        github:"https://github.com/matighigi"
    },
    {
        name: "Franco Malfetano",
        img: "https://res.cloudinary.com/dx3wowvsb/image/upload/v1673360694/photo about/1654212324081_cx71ki.jpg",
        linkedin: "https://www.linkedin.com/in/franco-malfetano/",
        github:"https://github.com/FrancoMal"
    },
    {
        name: "Facundo Agüero",
        img: "https://res.cloudinary.com/dx3wowvsb/image/upload/v1673360699/photo about/1548361275791_vpfoh4.jpg",
        linkedin: "https://www.linkedin.com/in/facundo-nicolas-ag%C3%BCero-casalongue-58477a163/",
        github:"https://github.com/Dota43ver"
    }
]